import * as Yup from 'yup';

// TODO type this better?
export function combineYupSchemas<T extends object>(
  schemas: Array<Yup.ObjectSchema<any>>,
): Yup.ObjectSchema<T> {
  return schemas.reduce((acc, schema) => acc.concat(schema));
}
